import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { utils, writeFile } from "xlsx";
import { Dropdown } from "primereact/dropdown";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
    createAPIEndpointPriceVariation,
    EndpointPriceVariation,
} from "../../Services/PriceVariation/PriceVariationService";

const PriceVariation = () => {
    const [getAvailablePriceList, setGetAvailablePriceList] = useState([]);
    const [selectedAvailablePriceList, setSelectedAvailablePriceList] = useState(
        null
    );
    const [getAllData, setGetAllData] = useState([]);

    const getAvailablePriceListData = async () => {
        try {
            const response = await createAPIEndpointPriceVariation().get(
                EndpointPriceVariation.GetAvailablePriceList
            );
            setGetAvailablePriceList(response.data);
        } catch (err) {
            console.error("Error ", err);
        }
    };

    const getAllProductData = async () => {
        if (!selectedAvailablePriceList) return;
        try {
            const response = await createAPIEndpointPriceVariation().get(
                `${EndpointPriceVariation.GetAllData}?PLNo=${selectedAvailablePriceList}&PercTag='`
            );
            setGetAllData(response.data);
        } catch (err) {
            console.error("Error ", err);
        }
    };

    const handleExport = async () => {
        try {
            const response = await createAPIEndpointPriceVariation().get(`${EndpointPriceVariation.GetExportData}?PLNo=${selectedAvailablePriceList}&PercTag=${"'"}`);
            if (response.data && response.data.length > 0) {
                exportToExcel(response.data);
            } else {
                toast.error("No data available to export!", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        } catch (err) {
            toast.error(err.message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };
    
    const exportToExcel = (data) => {
        if (!data || data.length === 0) {
            toast.error("No data to export!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        let date = new Date();
        let day = date.getDate();
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let exactmonths = months[date.getMonth()];
        let year = date.getFullYear();
        let uniqueNo = Math.floor(Math.random() * 10000);
        let filename = `PriceVariation_${day}${exactmonths}${year}_${uniqueNo}`;
        const ws = utils.json_to_sheet(data);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, filename);        
        writeFile(wb, `${filename}.xlsx`);
    };
    
    const handleDropdownChange = (e) => {
        setSelectedAvailablePriceList(e.value);
    };
    useEffect(() => {
        getAvailablePriceListData();
    }, []);

    useEffect(() => {
        if (selectedAvailablePriceList) {
            getAllProductData();
        }
    }, [selectedAvailablePriceList]);

    useEffect(() => {
        if (getAvailablePriceList.length > 0) {
            setSelectedAvailablePriceList(getAvailablePriceList[0]?.PRICE_LIST_NO);
        }
    }, [getAvailablePriceList]);

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Price Variation</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button type="submit" className="btn btn-primary" onClick={handleExport} >
                                Export
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <label className="form-label">Price List Number</label>
                                <Dropdown
                                    value={selectedAvailablePriceList}
                                    options={getAvailablePriceList}
                                    onChange={handleDropdownChange}
                                    optionLabel="PRICE_LIST_NO"
                                    optionValue="PRICE_LIST_ID"
                                />
                            </div>
                        </div>
                    </form>
                </section>
                <section>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3>Records</h3>
                        <div className="DataTable">
                            <DataTable
                                value={getAllData}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                filterDisplay="row"
                                // showGridlines
                                scrollable
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column
                                    field="PROD_CODE"
                                    header="Product Code"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="PROD_DESC"
                                    header="Product Description"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column field="LOWER_BAND" header="Lower Band"></Column>
                                <Column field="UPPER_BAND" header="Upper Band"></Column>
                            </DataTable>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PriceVariation;